import { render, staticRenderFns } from "./instances-survey-window.vue?vue&type=template&id=26dc51ca&scoped=true&"
import script from "./instances-survey-window.vue?vue&type=script&lang=ts&"
export * from "./instances-survey-window.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc51ca",
  null
  
)

export default component.exports